import React from "react";
import { Box, Container } from "@mui/material";

const AppShell = ({ children }) => {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        pt: 0,
        pb: { xs: 4, sm: 6 },
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        {children}
      </Container>
    </Box>
  );
};

export default AppShell;
